import { requestApi } from 'app/utils/RestApi';

const MFA_CHOICE_PARAM = 'MFA_CHOICE_PAGE';
const APPS = 'REFERRAL_MICROSITE';
const SUBJECT = 'LOGIN REFERRAL';

export const MFA_DEFAULTS = { APPS, SUBJECT, MFA_CHOICE_PARAM };

export function reqOtp({ identifier, username, type, uid }) {
  return requestApi('MFA_REQ_OTP', {
    data: { identifier, username, type, subject: SUBJECT, uid },
  });
}

export function verifyOtp({ identifier, username, type, otpCode, uid, trustDevice, detailInfo }) {
  return requestApi('MFA_VERIFY_OTP', {
    data: {
      identifier,
      username,
      type,
      subject: SUBJECT,
      otpCode,
      uid,
      trustDevice,
      detailInfo: detailInfo || {},
    },
  });
}

export function verifyToken({ identifier, username, uid, token }) {
  return requestApi('MFA_VERIFY_TOKEN', {
    data: { identifier, username, uid, token },
  });
}

export function deleteToken({ identifier, username, uid }) {
  return requestApi('MFA_DELETE_TOKEN', {
    data: { identifier, username, uid },
  });
}

export function fetchMfaChoiceFlag() {
  return requestApi('SYSTEM_PARAMETER', {
    subfolder: `/${MFA_CHOICE_PARAM}`,
  });
}
